import type { ProjectScope } from '../sync/project-scope';
import type { FeedPost } from './types';

export type FeedReadReceiptMap = Record<string, number>;

export interface FeedReadReceiptScope extends ProjectScope {
    userId: string;
}

export function feedReadReceiptKey(scope: FeedReadReceiptScope): string {
    return `${scope.orgId}/${scope.projectId}/${scope.userId}`;
}

export function getFeedReadReceipt(
    receipts: FeedReadReceiptMap | undefined,
    scope: FeedReadReceiptScope
): number | null {
    const receipt = receipts?.[feedReadReceiptKey(scope)];

    return typeof receipt === 'number' && Number.isFinite(receipt) && receipt >= 0
        ? receipt
        : null;
}

export function deriveInitialFeedReadReceipt(posts: FeedPost[]): number {
    const newestVisiblePostCreatedAt = posts.reduce((newest, post) => (
        !post.deleted && Number.isFinite(post.createdAt)
            ? Math.max(newest, post.createdAt)
            : newest
    ), 0);

    return newestVisiblePostCreatedAt;
}
